import Swiper from "swiper";
import "swiper/css/swiper.css";

var mainSliderEl = document.getElementById('main-carousel');
var shouldSliderInit = false;

if (mainSliderEl) {
  var mainSliderPanels = mainSliderEl.querySelectorAll('.swiper-slide');
  shouldSliderInit = mainSliderPanels.length > 1;
}

function mainCarousel() {
  new Swiper("#main-carousel", {
    init: shouldSliderInit,
    navigation: true,
    mousewheel: { forceToAxis: true },
    slidesPerView: "auto",
    // centeredSlides: true,
    freeMode: false,
    spaceBetween: 0,
    scrollbar: {
      el: ".navigation-secondary__scrollbar",
      hide: true
    },
    autoplay: true
  });

  var scrollBar = document.querySelector("#scroller");
  if (scrollBar) {
      scrollBar.onclick = function(){
          window.scrollBy(0,(window.innerHeight-150));
      }
  }

  var homevideobutton = document.querySelector("#home-video-trigger");
  if (homevideobutton) {
    homevideobutton.onclick = function(){
        if (homevideobutton.classList.contains("fa-play")) {
          homevideobutton.classList.remove("fa-play");
          homevideobutton.classList.add("fa-pause");
          document.querySelector("#home-video-holder").style.display = 'flex';
          document.querySelector("#home-video").play();
        } else {
          homevideobutton.classList.remove("fa-pause");
          homevideobutton.classList.add("fa-play");
          document.querySelector("#home-video-holder").style.display = 'none';
          document.querySelector("#home-video").pause();
        }
      }
  }
}

export default mainCarousel;
